import barba from '@barba/core';

import initJS from '../init';

const initBarba = () => {
	window.scrollTo(0, 0); //reset scroll

	//Hacky way to get barba to ignore the admin bar links, doing this cleanly in a hook didn't work...
	document
		.querySelectorAll('#wpadminbar a')
		.forEach((item) => item.setAttribute('data-barba-prevent', 'self'));

	//const thirdPartyCookiesAccepted = parseInt(gdprConsent.gdpr_consent__thirdparty) === 1 ? true : false;

	barba.hooks.after(() => {
		if (thirdPartyCookiesAccepted && typeof ga === 'function') {
			ga('set', 'page', window.location.pathname);
			ga('send', 'pageview');
		}
	});

	const transitionEl = document.querySelector('.js__barba-transition');

	barba.init({
		timeout: 5000,
		transitions: [

			{
				sync: true,
				async leave(data) {

	                	const leaveDone = this.async();

	                	//Transition In
	                	transitionEl.classList.add('transitioning');
	                	transitionEl.classList.add('transition-out');
	                	setTimeout(() => {
							leaveDone();
						},500);
	                	
	            },
            }
		]
	});
	barba.hooks.afterEnter((data) => {
		const pageLoadedWithBarba = data.trigger !== 'barba';
		
		if ( pageLoadedWithBarba ) {			
			document.querySelector('body').classList.remove('js__popup-active');
	
			//Reinitialise the JS
			setTimeout(() => { //Arbitary timeout to ensure that the old page has left the DOM completely
				initJS();
			},10);
	
			window.scrollTo(0, 0); 
	
			//Transition Out
			transitionEl.classList.remove('transition-out');
			transitionEl.classList.add('transition-in');
			setTimeout(() => {
				transitionEl.classList.remove('transitioning');
				transitionEl.classList.remove('transition-in');
			},900);
		}
	});
};
initBarba();




